/* ============================================================
   fly-to-cart.js  (Dawn / Trade compatible)
   Circular add-to-cart button -> animates the product image
   as a circle into the header cart, then adds via AJAX.

   Safe to load multiple times: the guard below ensures the
   click listener is only ever attached once.
   ============================================================ */
(function () {
  'use strict';

  // ---- guard: only initialise once even if the file loads many times ----
  if (window.__flyToCartReady) return;
  window.__flyToCartReady = true;

  var CART_SELECTORS = [
    '#cart-icon-bubble',
    '.header__icon--cart',
    'a[href$="/cart"]',
  ];

  function getCartIcon() {
    for (var i = 0; i < CART_SELECTORS.length; i++) {
      var el = document.querySelector(CART_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ---- the flying circle animation ----
     startEl = the button the user pressed (where the flight begins)
     imgEl   = the product image (used as the flying picture)
     cartEl  = the header cart icon (where the flight ends) */
  function flyImage(startEl, imgEl, cartEl) {
    if (!startEl || !imgEl || !cartEl) return;

    var s = startEl.getBoundingClientRect();
    var c = cartEl.getBoundingClientRect();
    var startSize = Math.max(38, Math.min(s.width, s.height));
    var endSize = 16;

    // flight begins at the centre of the button that was tapped
    var startX = s.left + s.width / 2 - startSize / 2;
    var startY = s.top + s.height / 2 - startSize / 2;
    var endX = c.left + c.width / 2 - endSize / 2;
    var endY = c.top + c.height / 2 - endSize / 2;

    var clone = document.createElement('img');
    clone.src = imgEl.currentSrc || imgEl.src;
    clone.className = 'fly-clone';
    clone.style.width = startSize + 'px';
    clone.style.height = startSize + 'px';
    document.body.appendChild(clone);

    var peakX = startX + (endX - startX) * 0.5;
    var peakY = Math.min(startY, endY) - 110;
    var endScale = endSize / startSize;

    var anim = clone.animate(
      [
        { transform: 'translate(' + startX + 'px,' + startY + 'px) scale(1) rotate(0deg)', opacity: 1, offset: 0 },
        { transform: 'translate(' + peakX + 'px,' + peakY + 'px) scale(0.55) rotate(170deg)', opacity: 1, offset: 0.55 },
        { transform: 'translate(' + endX + 'px,' + endY + 'px) scale(' + endScale + ') rotate(360deg)', opacity: 0.25, offset: 1 },
      ],
      { duration: 820, easing: 'cubic-bezier(0.5,-0.2,0.7,1)' }
    );

    anim.onfinish = function () {
      clone.remove();
      bumpCart(cartEl);
    };
    setTimeout(function () {
      if (clone.parentNode) clone.remove();
    }, 1200);
  }

  function bumpCart(cartEl) {
    cartEl.classList.remove('fly-cart-bump');
    void cartEl.offsetWidth;
    cartEl.classList.add('fly-cart-bump');
  }

  /* ---- refresh the cart count / drawer from returned section HTML ---- */
  function applySections(sections) {
    if (!sections) return;

    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        var parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var fresh = parsed.querySelector('.shopify-section') || parsed.body;
        if (fresh) bubble.innerHTML = fresh.innerHTML;
      }
    }

    if (sections['cart-drawer']) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        var parsedD = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var freshInner = parsedD.querySelector('.drawer__inner');
        var curInner = drawer.querySelector('.drawer__inner');
        if (freshInner && curInner) curInner.innerHTML = freshInner.innerHTML;
        drawer.classList.remove('is-empty');
      }
    }
  }

  function refreshCountFallback() {
    fetch(root() + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble span').forEach(function (span) {
          if (span.getAttribute('aria-hidden') === 'true') {
            span.textContent = cart.item_count;
          }
        });
      })
      .catch(function () {});
  }

  /* ---- the add-to-cart request ---- */
  function addToCart(btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.classList.contains('is-loading')) return;

    btn.classList.add('is-loading');

    var card = btn.closest('.card-wrapper') || btn.closest('.card');
    var img = card ? card.querySelector('.card__media img, .media img') : null;
    var cartEl = getCartIcon();

    if (cartEl) flyImage(btn, img, cartEl);

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: Number(id), quantity: 1 }],
        sections: 'cart-icon-bubble,cart-drawer',
        sections_url: window.location.pathname,
      }),
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.status) {
          console.warn('[fly-to-cart] add failed:', data.description || data.message);
          return;
        }
        if (data && data.sections) {
          applySections(data.sections);
        } else {
          refreshCountFallback();
        }
        document.dispatchEvent(new CustomEvent('fly-to-cart:added', { detail: data }));
      })
      .catch(function (err) {
        console.error('[fly-to-cart] request error:', err);
      })
      .finally(function () {
        setTimeout(function () { btn.classList.remove('is-loading'); }, 650);
      });
  }

  /* ---- one delegated listener handles every card on the page ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fly-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    addToCart(btn);
  });
})();
